import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedin,
  FaGooglePlay,
  FaApple,
} from "react-icons/fa";

const Footer = () => {
  const { pathname } = useLocation();

  // ❌ Hide on auth pages if needed
  const hiddenRoutes = [
    "/login",
    "/register",
    "/forgot-password",
    "/reset-password",
    // "/materials",
    // "cart",
    // "orders",
  ];

  // Hide on dashboard routes (Supplier & Customer) as they have their own layout-integrated footer
  if (hiddenRoutes.includes(pathname)) {
    return null;
  }

  // Add margin for dashboard routes where sidebar is present
  const isDashboard =
    pathname.startsWith("/supplier") ||
    pathname.startsWith("/customer") ||
    pathname === "/customer-dashboard";

  return (
    <footer
      className={`bg-blue-950 text-gray-300 pt-3 pb-3 px-4 border-t border-blue-800 mt-auto ${
        isDashboard ? "md:ml-64" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
        {/* 🧱 Brand Overview */}
        <div>
          <h2 className="text-lg font-bold text-white mb-2">
            ConnectingConstructions
          </h2>
          <p className="text-sm leading-6">
            The One-Stop platform for construction
            <br />— your all-in-one construction ecosystem.
            <br />
            <strong className="italic">Connecting Core and Code</strong>
          </p>
          <div className="flex gap-4 mt-2">
            <a href="#" className="text-white text-lg hover:text-gray-300">
              <FaGooglePlay />
            </a>
            <a href="#" className="text-white text-lg hover:text-gray-300">
              <FaApple />
            </a>
          </div>
        </div>

        {/* 📌 Quick Navigation */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-2 ">
            Quick Links
          </h3>
          <ul className="space-y-2 text-sm ">
            <li>
              <Link to="/" className="hover:text-white">
                🏠 Home
              </Link>
            </li>
            <li>
              <Link to="/materials" className="hover:text-white">
                🧱 Materials
              </Link>
            </li>
            <li>
              <Link to="/customer/cart" className="hover:text-white">
                🛒 Cart
              </Link>
            </li>
            <li>
              <Link
                to="/customer/orders"
                className="hover:text-white"
              >
                📜 Orders
              </Link>
            </li>
            <li>
              <Link to="/customer-dashboard" className="hover:text-white">
                📊 Dashboard
              </Link>
            </li>
          </ul>
        </div>

        {/* 📦 Categories (Top 5 Only) */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-2">
            Top Categories
          </h3>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/category/cement" className="hover:text-white">
                Cement
              </Link>
            </li>
            <li>
              <Link to="/category/rmc" className="hover:text-white">
                RMC
              </Link>
            </li>
            <li>
              <Link to="/category/trucks" className="hover:text-white">
                Trucks
              </Link>
            </li>
            <li>
              <Link to="/category/morrum" className="hover:text-white">
                Morrum
              </Link>
            </li>
            <li>
              <Link to="/category/interiors" className="hover:text-white">
                Interiors
              </Link>
            </li>
          </ul>
        </div>

        {/* 📞 Contact + Social */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-2">
            Get in Touch
          </h3>
          <div className="space-y-2 text-sm mb-4">
            <a
              href="https://www.google.com/maps/search/?api=1&query=Hyderabad,+Telangana,+India"
              target="_blank"
              rel="noopener noreferrer"
              className="block hover:text-blue-300 transition duration-200"
            >
              Hyderabad, Telangana, India
            </a>
            <a
              href="mailto:connectingconstructions@gmail.com"
              className="block hover:text-blue-400 transition duration-200"
            >
              connectingconstructions@gmail.com
            </a>
          </div>

          {/* Social Media */}
          <div className="flex gap-4 text-lg">
            <a
              href="#"
              className="hover:text-blue-500 hover:scale-110 transform transition duration-200"
            >
              <FaFacebookF />
            </a>
            <a
              href="#"
              className="hover:text-pink-400 hover:scale-110 transform transition duration-200"
            >
              <FaInstagram />
            </a>
            <a
              href="#"
              className="hover:text-sky-400 hover:scale-110 transform transition duration-200"
            >
              <FaTwitter />
            </a>
            <a
              href="#"
              className="hover:text-blue-400 hover:scale-110 transform transition duration-200"
            >
              <FaLinkedin />
            </a>
          </div>
        </div>
      </div>

      {/* 🧾 Legal Row */}
      <div className="mt-10 border-t border-blue-800 pt-6 text-sm text-center text-gray-400">
        <p>
          &copy; {new Date().getFullYear()}{" "}
          <span className="text-white font-semibold">
            ConnectingConstructions
          </span>
          . All rights reserved.
        </p>
        {/* 🔥 Main Legal Category Links */}
        <div className="mt-2 flex justify-center gap-6 flex-wrap text-white font-medium">
          <Link to="/legal/core-policies" className="hover:underline">
            Core Policies
          </Link>
          <Link to="/legal/supplier-partner" className="hover:underline">
            Supplier & Partner
          </Link>
          <Link to="/legal/customer-platform" className="hover:underline">
            Customer & Platform
          </Link>
          <Link to="/legal/smart-platform" className="hover:underline">
            Smart Platform
          </Link>
          <Link to="/legal/monetization" className="hover:underline">
            Monetization
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
